import { Component, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { Resource, ResourceService, EnvironmentConfig, TrackingService, EVENTS, CurrencyChangerService, ListingService } from '@clooper/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import { BookingRestrictionModalComponent } from '../booking-restriction-modal/booking-restriction-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { faHouseUser } from '@fortawesome/pro-light-svg-icons/faHouseUser';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faChild } from '@fortawesome/pro-light-svg-icons/faChild';
import { faBaby } from '@fortawesome/pro-light-svg-icons/faBaby';
import { faCat } from '@fortawesome/pro-light-svg-icons/faCat';
import { faSlidersH } from '@fortawesome/pro-light-svg-icons/faSlidersH';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons/faCalendarPlus';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faChevronDown, faHotel, faLocation, faTimes } from '@fortawesome/pro-light-svg-icons';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar-v2',
  templateUrl: './search-bar-v2.component.html',
  styleUrls: ['./search-bar-v2.component.scss']
})
export class SearchBarV2Component implements OnDestroy {

  @Input() resource: string;
  @Input() service: ResourceService<Resource>;
  @Output() resources: EventEmitter<any> = new EventEmitter();
  @Output() onsearch: EventEmitter<any> = new EventEmitter();
  @Output() pushForEnquiry: EventEmitter<any> = new EventEmitter();
  minDate: Date;

  bsModalRef?: BsModalRef;

  occupant_types = [
    { name: 'rooms', icon: faHouseUser, subText: '', default: 1 },
    { name: 'adults', icon: faUsers, subText: '', default: 1 },
    { name: 'children', icon: faChild, subText: '(2-17 years)', default: 0 },
    { name: 'infants', icon: faBaby, subText: '(Under 2 years)', default: 0 },
    { name: 'pets', icon: faCat, subText: '', default: 0 },
  ]

  occupant_form_array: { [x: string]: FormControl; }[] = []
  form: FormGroup
  dateRange: Date[];

  /** Boolean variable for enabling and disabling the search bar */
  isSearchBtnEnabled: boolean = false;

  filter: any = {
    // search: true
  };

  icons = {
    search: faSearch,
    sliderH: faSlidersH,
    caretDown: faAngleDown,
    calendar: faCalendarPlus,
    caretUp: faAngleUp,
    users: faUsers,
        chevronDown: faChevronDown,
         hotel: faHotel,
            location: faLocation,
                close: faTimes,
            
    
  }
  latlng: any
  searchRadius = 20;
  miles = [5, 10, 20, 30, 40, 50, 60, 70, 80];
  currentUrl: string = "/listings";
  routerSubs: any;
  searchValue: string;
  checkIn: Date;
  checkOut: Date;
  queryParamsSubs: Subscription;
  selectedCurrency: string = 'GBP';
selectedChildAgesIndex: any[] = []
    selectedChildAges: any[] = []
childSelectHidden: boolean = false;
childAge = Array.from({ length: 17 }, (_, i) => i + 1); // [1, 2, 3, ..., 17]
  searchSubject = new Subject<string>();

  constructor(
    private route: ActivatedRoute,
    private tracker: TrackingService,
    private fb: FormBuilder,
    private router: Router,
    private modalService: BsModalService,
    private currency: CurrencyChangerService,
        private env: EnvironmentConfig,
        private listingService: ListingService

  ) {
    const data = this.currency.getSelectedCurrency()
    if (data !== null) {

      this.selectedCurrency = data?.currency;
    } else {
      this.selectedCurrency = 'GBP'
    }

    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());

    this.occupant_form_array = this.occupant_types.map(occupant_type => {
      return {
        [occupant_type.name + ""]: new FormControl(occupant_type.default, []),
      }
    });
    let occupant_form = Object.assign({}, ...this.occupant_form_array);
    this.form = this.fb.group({
      rooms: new FormControl('', []),
      check_in: new FormControl('', []),
      check_out: new FormControl('', []),
      occupants: new FormControl('', []),
      bookingDataVm: this.fb.array([]),
      ...occupant_form
    })
    this.addBookingData()

    this.routerSubs = this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url

        }
      })

    this.queryParamsSubs = this.route.queryParams.subscribe((params) => {
      this.latlng = params.latlng
      this.searchValue = params.s || ''
      this.airlineSearch = params.s

      if (+params.checkIn && +params.checkOut) {
        this.checkIn = new Date(+params.checkIn)
        this.checkOut = new Date(+params.checkOut)
        this.dateRange = [this.checkIn, this.checkOut]
      }

      // Clear existing booking data
      this.bookingDataArr.clear();

      // Parse guests params
      const guests: any[] = [];
      Object.keys(params).forEach(key => {
        const match = key.match(/guests\[(\d+)\]\[(\w+)\]/);
        if (match) {
          const index = +match[1];
          const field = match[2];

          if (!guests[index]) {
            guests[index] = { adults: 1, children: [], pets: 0 };
          }

          if (field === 'adults') {
            guests[index].adults = +params[key] || 1;
          }

          if (field === 'children') {
            guests[index].children = JSON.parse(params[key] || '[]');
          }
        }
      });

      // If no guests params, fall back to old style
      if (guests.length === 0) {
        +params.rooms ? this.form.controls['rooms'].setValue(+params.rooms) : null;
        +params.adults ? this.form.controls['adults'].setValue(+params.adults) : null;
        +params.children ? this.form.controls['children'].setValue(+params.children) : null;
        +params.pets ? this.form.controls['pets'].setValue(+params.pets) : null;
        +params.infants ? this.form.controls['infants'].setValue(+params.infants) : null;

        // Add default room if no guests
        if (!this.bookingDataArr.length) {
          this.addBookingData();
        }
      } else {
        // Populate bookingDataVm from guests
        guests.forEach(guest => {
          const roomGroup = this.fb.group({
            adults: [guest.adults],
            children: [guest.children],
            pets: [guest.pets || 0],
          });
          this.bookingDataArr.push(roomGroup);
        });
      }

      this.constructString()
    })
  }

  ngOnInit(): void {
    this.constructString()
    this.form.valueChanges.subscribe(() => {
      this.constructString()
    })
     this.searchSubject
        .pipe(
          debounceTime(1000),
          distinctUntilChanged()
        )
        .subscribe((value: any) => {
          this.searchLocation(value);
        });
  }

  onSearchChange(value: string) {
      this.searchSubject.next(value);
    }

  ngOnDestroy(): void {
    this.routerSubs.unsubscribe()
    this.queryParamsSubs.unsubscribe()
  }

  reset() {
    this.filter = {
      // search: true
    }
  }



  radiusChange(radius: number) {
    this.searchRadius = radius || 10;
    this.filter = { ...this.filter, radius };
  }

  /** This method checks if the occupants field and check-in checkout date fields are truthy then it update the boolean variable for enabling the search form.*/
  updateSelection(): void {
    const occupants = this.form.get('occupants')?.value;
    if (occupants && this.dateRange) this.isSearchBtnEnabled = true;
  }


  onDateRangeChange(newValue: string) {
    // Handle the updated value of dateRange
    this.handleNoOfDaysCheckedIn(newValue[0], newValue[1])

  }

  /**
   * This method calculates the number of selected days. If the number of selected days is greater than 21, it logs the message "More than 21 days" to the console. Otherwise, it logs Not More than
   */
  handleNoOfDaysCheckedIn(checkinDate: any, checkoutDate: any) {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
    const selectedDays = Math.round(Math.abs((checkoutDate - checkinDate) / oneDay));
    // console.log(selectedDays)
    if (selectedDays > 21) {
      // console.log('More than 21 days');
      const options: any = { class: 'modal-rounded' }
      this.bsModalRef = this.modalService.show(BookingRestrictionModalComponent, options)
      this.bsModalRef.content.onClose.subscribe((res: any) => {
        if (res === true) {
          this.dateRange = []
        }
      })
    }
  }



  buildBookingParams(data: any) {

 let query: any = [];
  // guests array from bookingDataVm
 data.bookingDataVm.forEach((room: any, index: any) => {
    query.push(`guests[${index}][adults]=${room.adults}`);

    // normalize children
    let children =
      Array.isArray(room.children) && room.children.length > 0
        ? `[${room.children.join(",")}]`
        : "[]";

    query.push(`guests[${index}][children]=${children}`);
    query.push(`guests[${index}][pets]=${room.pets}`);
  });

  return "?" + query.join("&");
}


buildGuestsQueryString(formValue: any): string {
  const rooms = formValue.bookingDataVM ?? formValue.bookingDataVm ?? [];
  const parts: string[] = [];

  rooms.forEach((room: any, i: number) => {
    parts.push(`guests[${i}][adults]=${Number(room.adults ?? 0)}`);

    const children = Array.isArray(room.children) ? room.children : [];
    parts.push(`guests[${i}][children]=[${children.map(Number).join(",")}]`);
  });

  return parts.join("&");
}


buildBaseQueryString(obj: Record<string, any>): string {
  const parts: string[] = [];

  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  });

  return parts.join("&");
}


isAdminApp(): boolean {
  const { hostname, port } = window.location;

  const isAdminDomain = hostname.includes('admin');
  const isLocalAdmin = hostname === 'localhost' && port === '5333';

  return isAdminDomain || isLocalAdmin;
}



  search(params?: any) {
    // Restriction check
  if (this.bookingDataArr?.length > 9) {
    const options: any = { class: 'modal-rounded' };

    this.bsModalRef = this.modalService.show(
      BookingRestrictionModalComponent,
      options
    );

    this.bsModalRef.content.onClose.subscribe((res: any) => {
      if (res === true) {
        this.dateRange = [];
      }
    });

    return; // Stop execution if restriction is triggered
  }

    const paginationParams = { page: 1, size: 20, currency: this.selectedCurrency }
    // const { rooms, adults, children, pets, infants } = this.form.value
    const { bookingDataVM } = this.form.value
    const d = this.buildBookingParams(this.form.value)
    const queryParams: any = {
      ...this.filter,
      ...paginationParams,
      checkIn: this.dateRange ? this.dateRange[0]?.getTime() : 0,
      checkOut: this.dateRange ? this.dateRange[1]?.getTime() : 0,
    }
    console.log(queryParams)
    if (!queryParams.radius) {
      queryParams.radius = this.searchRadius;
    }
    if (this.selectedLocation?.region_id) { 
      queryParams.region_id = this.selectedLocation?.region_id

    }
    console.log('Search initiated with params:', queryParams);
    const baseQS = this.buildBaseQueryString(queryParams);
  const guestsQS = this.buildGuestsQueryString(this.form.value);
  const isAdmin = this.isAdminApp();

const path = isAdmin
  ? '/bookings/create-booking/listings'
  : '/listings';

const finalUrl = `${path}?${baseQS}${guestsQS ? `&${guestsQS}` : ""}`;

console.log(finalUrl, 'finalUrl');

localStorage.setItem('xQuery', finalUrl);
this.router.navigateByUrl(finalUrl);
console.log(this.selectedLocation, 'selectedLocation')
if (this.selectedLocation?.region_id && this.selectedLocation?.hid) {
  
  window.open(`/listings/hotel-apartments/${this.selectedLocation?.id}?checkIn=${this.dateRange[0]?.getTime()}&checkOut=${this.dateRange[1]?.getTime()}${guestsQS ? `&${guestsQS}` : ""}&tx=${'rk'}`, '_blank'); // tx is the tracking parameter for ratehawk
} else {
  this.router.navigateByUrl(finalUrl);

  // route to hotel page
}
// if (this.isAdminDomain() || this.env.adminUrl?.includes('localhost:5333')) {
//   const finalUrl = `/bookings/create-booking/listings?${baseQS}${guestsQS ? `&${guestsQS}` : ""}`;
//     console.log(finalUrl, 'finalUrl')
//     localStorage.setItem('xQuery', finalUrl)
//   this.router.navigateByUrl(finalUrl);

// } else {
//   const finalUrl = `/listings?${baseQS}${guestsQS ? `&${guestsQS}` : ""}`;
//     console.log(finalUrl, 'finalUrl')
//     localStorage.setItem('xQuery', finalUrl)
//   this.router.navigateByUrl(finalUrl);

// }
    // this.tracker.track(EVENTS.SEARCH_PROPERTY, {});
    // if (this.currentUrl.includes('/listings') && (this.currentUrl.includes('page') || this.currentUrl.includes('search'))) {
    //   this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    // }
    // else {
    //   this.router.navigate(['/listings'], { queryParams, /* queryParamsHandling: 'merge' */ });
    // }

    // this.handleNoOfDaysCheckedIn(queryParams.checkIn, queryParams.checkOut)

    this.onsearch.emit()
    // Commented out to prevent calling search endpoint twice, as pagination is callling endpoint as well.
    // this.service.search(queryParams).subscribe((resp: any) => {
    //   this.resources.emit(resp);
    // })
  }

  openFilter(template?: TemplateRef<any>) {
    // this.bsModalRef = this.modalService.show(template, {class: 'modal-rounded modal-content-p0'});
  }

  locationChange(data: any) {
    const latlng = data.latlng.join(',');
    this.latlng = data.latlng.join(',');
    this.filter = { ...this.filter, latlng, s: data.s };

  }

  filters(params: any) {
    this.filter = { ...this.filter, ...params };
  }

  locationInputChange(event: any) {
    if (!event.value) {

    }
  }



  increment(name: string) {
    this.form.controls[name].setValue(+this.form.value[name] + 1)
    this.constructString()

  }

  decrement(name: string) {
    if (+this.form.value[name] > 0) {
      this.form.controls[name].setValue(+this.form.value[name] - 1)
      this.constructString()
    }
  }

  constructString() {
        const {bookingDataVm} = this.form.value;
        const value = this.formatGuestCount(bookingDataVm)


    this.form.controls['occupants'].setValue(value);
    console.log(value, 'constructed string')
  }




    asFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

     get bookingDataArr() {
        return this.form.get('bookingDataVm') as FormArray;
      }

    addBookingData() {
      const data = this.fb.group({
        adults: [1],
        children: [''],
        pets: [0],
      });
      // const data = new FormGroup({
      //     adults: new FormControl(0),
      //     pets: new FormControl(0),
      //   });
        this.form?.valueChanges.subscribe((value) => {
          // console.log('Booking Data VM changed:', value);
          // You can perform additional actions here when the value changes
        });

      this.bookingDataArr.push(data);


    }


 addRoom() {
        this.bookingDataArr.push(this.fb.group({
          adults: [1],
          children: [''],
          pets: [0],
        }) );
        this.childSelectHidden = false
        this.constructString()
        // this.childSelectHidden.push(false);
      }


     setChildAge(selectEl: any, roomIndex: number) {
  const age = +selectEl.value;
  if (Number.isNaN(age)) return;

  const roomGroup = this.bookingDataArr.at(roomIndex) as FormGroup;
  const childrenCtrl = roomGroup.get('children')!; // FormControl<number[]>

  const current: number[] = (childrenCtrl.value ?? []) as number[];

  // prevent duplicates if you want
  if (current.includes(age)) {
    selectEl.value = '';
    return;
  }

  childrenCtrl.setValue([...current, age]); // ✅ new array copy (no shared reference)
  selectEl.value = ''; // reset dropdown
}


    removeRoom(index: number) {
      this.bookingDataArr.removeAt(index);
      this.constructString()
      // this.childSelectHidden.splice(index, 1);
    }

    manageChildSelect(i: number, selectElement: any) {
      console.log(selectElement);
      selectElement.hidden = true;
      this.childSelectHidden = true;

}

addChildAge() {

  this.childSelectHidden = false
}

 removeAge(roomIndex: number, ageIndex: number) {
  const roomGroup = this.bookingDataArr.at(roomIndex) as FormGroup;
  const childrenCtrl = roomGroup.get('children')!;

  const current: number[] = (childrenCtrl.value ?? []) as number[];

  const updated = current.filter((_, index) => index !== ageIndex);

  childrenCtrl.setValue(updated);


}


// testing new location search
   airlineSearch = '';
  showLocationDropdown = false;
  selectedLocation: any;
  selectedAirline: any;
  filteredLocations: any
locationLoading: boolean  = false
  searchQuery: string = '';
  predictions: any = [];


  toggleLocationDropdown(): void {
    this.showLocationDropdown = !this.showLocationDropdown;
    if (this.showLocationDropdown) {
      this.airlineSearch = '';
      // this.filteredLocations = this.airlines;
    }
  }

 searchLocation(term: string): void {
  this.searchQuery = term
    // const term = this.airlineSearch.toLowerCase();
    console.log(term)
    const payload = {
      query: term
    }
         
    this.locationLoading = true;
    this.listingService.fetchListingViaAutocomplete(payload).subscribe((resp: any) => {
      console.log(resp)
      this.filteredLocations = resp.data;
      this.locationLoading = false;
  const service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        {
          input: term,
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            console.log(predictions);
            this.showLocationDropdown = true;
            this.predictions = predictions;
          }
        },
      );
      if (!term) {
        this.predictions = [];
        return;
      }
      this.showLocationDropdown = true;
    })

  }
  

    selectPrediction(prediction: google.maps.places.AutocompletePrediction) {
      const service = new google.maps.places.PlacesService(
        document.createElement('div'),
      );
  
      service.getDetails(
        {
          placeId: prediction.place_id,
        },
        (place: any) => {
          console.log(place);
          const address = this.getAddress(place.address_components);
          const { lat, lng } = place.geometry.location as any;
          const latlng = [lat(), lng()];
          const s = place.formatted_address;
          console.log({ address, latlng, s, place });
          this.selectedLocation = { address, latlng, name: s, place, placeId: place?.place_id };
          console.log(this.selectedLocation)
          this.airlineSearch = s
          const newLatlng = latlng.join(',');
    
          this.filter = { ...this.filter, s, latlng: newLatlng };

          this.showLocationDropdown = false
        },
      );
    }


    private getAddress(address_components: any) {
    const {
      premise,
      street_number,
      route,
      administrative_area_level_2,
      postal_town,
      administrative_area_level_1,
      country,
      postal_code,
      postal_code_prefix,
    } = this.getAddressComponents(address_components);
    const input: any = this.searchQuery;
    const house_no_match = /^(\d{1,})/.exec(input);
    const house_no = house_no_match ? house_no_match[1] : '';
    const address: any = {
      house_no:
        street_number?.long_name || premise?.long_name || house_no || '',
      street: route?.long_name || '',
      city: administrative_area_level_2?.long_name || '',
      town: postal_town?.long_name || '',
      state: administrative_area_level_1?.long_name || '',
      country: country?.long_name || '',
      postcode: postal_code?.long_name || postal_code_prefix?.long_name || '',
    };
    let missing = ['street', 'postcode', 'country'].find((key) => {
      return address[key] === '';
    });
    return address;
  }

  private getAddressComponents(address: any[]) {
    return address.reduce((result, addr) => {
      const type = addr.types[0];
      result[type] = addr;
      return result;
    }, {});
  }


   selectLocation(data: any): void {
      this.selectedLocation = data;
      this.airlineSearch = data?.region_id && data?.hid ? data?.name : `${data?.name}, ${data?.country_name}`
      this.showLocationDropdown = false;
    
    if (data?.region_id) {
      const latlong: any = [data?.latitude, data?.longitude]
      const latlng = latlong.join(',');
    
          this.filter = { ...this.filter, s: `${data?.name}, ${data?.country_name}`, region_id: data?.region_id, latlng };
          console.log(this.filter)
    }
      this.showLocationDropdown = false;
    }


    clear() {
      this.toggleLocationDropdown()
      this.selectedLocation = {}
    }

    isLocationSelected(): boolean {
      return !!(
        this.selectedLocation?.region_id ||
        this.selectedLocation?.placeId ||
        this.selectedLocation?.hid ||
        this.selectedLocation?.id
      );
    }

     showList() {
        if (this.filteredLocations?.length > 0 || this.predictions?.length > 0) {
          
          this.showLocationDropdown = true;
        }
      }


    formatGuestsFromUrl(urlString: any) {
    // 1. Parse the URL and get the query parameters
    const url = new URL(urlString);
    const params: any = new URLSearchParams(url.search);
    
    const guestsMap: any = {};

    // 2. Loop through all parameters to find and group 'guests'
    for (const [key, value] of params.entries()) {
        // Match pattern: guests[index][property]
        const match = key.match(/^guests\[(\d+)\]\[(\w+)\]$/);
        
        if (match) {
            const index = match[1];
            const property = match[2];

            // Initialize the guest object if it doesn't exist yet
            if (!guestsMap[index]) {
                guestsMap[index] = { adults: 0, children: [], pets: 0 };
            }

            // Assign the value based on the property type
            if (property === 'children') {
                try {
                    guestsMap[index].children = JSON.parse(value);
                } catch (e) {
                    guestsMap[index].children = [];
                }
            } else {
                guestsMap[index][property] = Number(value) || 0;
            }
        }
    }

    // 3. Convert our grouped object map into an array
    const guestsArray = Object.values(guestsMap);

    // 4. Calculate totals
    let totalAdults = 0;
    let totalChildren = 0;
    // let totalPets = 0;

    guestsArray.forEach((guest: any) => {
        totalAdults += guest.adults || 0;
        // totalPets += guest.pets || 0;
        if (Array.isArray(guest.children)) {
            totalChildren += guest.children.length;
        }
    });

    return `Adults ${totalAdults}, Children ${totalChildren}`;
}


formatGuestCount(guests: any) {
    if (!Array.isArray(guests)) return "Adults 0, Children 0, Pets 0";

    let totalAdults = 0;
    let totalChildren = 0;
    let totalPets = 0;

    guests.forEach(guest => {
        // 1. Sum up adults
        totalAdults += Number(guest.adults) || 0;

        // 2. Sum up pets (default to 0 if the property is missing)
        totalPets += Number(guest.pets) || 0;

        // 3. Handle children (handles both actual arrays and stringified arrays)
        let childrenArray = guest.children;
        if (typeof childrenArray === 'string') {
            try {
                childrenArray = JSON.parse(childrenArray);
            } catch (e) {
                childrenArray = [];
            }
        }

        if (Array.isArray(childrenArray)) {
            totalChildren += childrenArray.length;
        }
    });

    return `Adults ${totalAdults}, Children ${totalChildren}, Pets ${totalPets}`;
}

// Output: "Adults 6, Children 5, Pets 3"


}
